export default "__VITE_ASSET__f06450b3__"